import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import { Label, Value } from '../Styling';

interface LocationProps {
  location: { address: string, city: string; country: string; } | null;
}

const Location = ({ location }: LocationProps) => (
  <Box data-testid="location-block" mt="6px" flexDirection="column">
    <Label>{s__('Mentoring|Location')}</Label>
    <Value>
      {location ? (
        <Dotdotdot clamp={1}>
          {[location.city, location.country].filter(Boolean).join(', ') ||
            location.address}
        </Dotdotdot>
      ) : (
        '-'
      )}
    </Value>
  </Box>
);

export default Location;
